<template>
  <div style="width: 100%; text-align:right;">
    <v-icon @click="addNew" class="btnAdd" v-tooltip:left="{ html: 'הוסף חדש' }">add</v-icon>
    <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable" style="padding: 20px!important; border:none; width: 100%;">
      <tr class="trPrint trHeader">
        <th class="tdData sp">שם חבילה</th>
        <th class="tdData">מספר יומנים</th>
        <th class="tdData">מחיר ₪</th>
        <th class="tdCtrl" style="width: 160px!important;"></th>
      </tr>
    </table>
    <div class="scrollContent" v-if="hasData">
      <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1" style="border:none;">
        <tr v-for="row in packages">
          <td class="tdData  sp">{{row.Name}}</td>
          <td class="tdData tdTxt">{{row.Diaries}}</td>
          <td class="tdData tdTxt">{{currency(row.Price)}}</td>
          <td class="tdCtrl tdTxt" style="width: 160px!important;">
            <v-icon @click="edit(row)" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'עריכה' }">border_color</v-icon>
            <v-icon @click="confirm(row)" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'מחיקה' }">delete</v-icon>
          </td>
        </tr>
      </table>
    </div>
    <div fluid v-else>
      <h3 style="padding-top: 40px;">אין נתונים</h3>
    </div>
    <PopupPackage></PopupPackage>
  </div>
</template>

<script>
 
  import { db } from '../firebase';
  var packagesRef = db.ref('Packages');
  import PopupPackage from './PopupPackage';

  export default {
    name: 'TablePackages',
    components: { PopupPackage },
    data() {
      return {
        packages:[],
        popup: {
          isVisible: false,
          title: '',
          question: '',
          caller: '',
          isConfirmed: false,
          data: { '.key': '', Name: '', Diaries: 0, Price: 0 },
        }
      }
    },
    firebase: function () {
      var vm = this;
      return {
        packages: packagesRef.orderByKey()
      }
    },
    created() {
      this.$Log("Vue [TablePackages] is created ...");
    },
    ready() {
      this.$Log("Vue [TablePackages] is ready ...");
    },
    mounted() {
      this.$Log("Vue [TablePackages] is mounted ...");
    },
    updated() {
      this.$Log("Vue [TablePackages] is updated ...");
    },
    computed: {
      hasData() {
        return this.packages != null && this.packages != undefined && this.packages.length > 0;
      }
    },
    watch: {
      '$root.confirm.isConfirmed'(val) {
        if (val && this.$root.confirm.caller == 'RemovePackage') {
          this.remove();
        }
      }
    },
    methods: {
      currency(N) {
        N = parseFloat(N);
        if (!isNaN(N))
          N = N.toFixed(2);
        else
          N = '0.00';
        return N + " ₪";
      },
      addNew() {
        this.popup = {
          isVisible: true,
          isEdit: false,
          title: 'חבילה חדשה',
          data: { '.key': '', Name: '', Diaries: 0, Price: 0 }
        };
      },
      edit(row) {
        this.popup = {
          isVisible: true,
          isEdit: true,
          title: 'עריכת חבילה',
          data: { '.key': row['.key'], Name: row.Name, Diaries: row.Diaries, Price: row.Price }
        };
      },
      confirm(row) {
        this.popup.data = row;
        this.$root.confirm = {
          isVisible: true,
          title: 'מחיקה',
          question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
          caller: 'RemovePackage',
          isConfirmed: false
        }
      },
      remove() {
        packagesRef.child(this.popup.data['.key']).remove();
      },
      insert() {
        var item = { Name: this.popup.data.Name, Diaries: this.popup.data.Diaries, Price: this.popup.data.Price };
        packagesRef.push(item);
      },
      update() {
        var item = { Name: this.popup.data.Name, Diaries: this.popup.data.Diaries, Price: this.popup.data.Price };
        packagesRef.child(this.popup.data['.key']).set(item);
      }
    }
  }

</script>
<style>
</style>



// WEBPACK FOOTER //
// TablePackages.vue?457956eb